import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ roles, children }) {
  const { user, pendingBranches, needsBranchPin } = useAuth();
  const location = useLocation();

  if (user === undefined) {
    return (
      <div className="flex h-screen items-center justify-center text-sm text-ink-muted">
        <div className="animate-pulse">Loading CareO — EMR for Eye Care…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  // User is logged in but has not picked a branch yet (or still needs to enter the Branch PIN).
  if ((pendingBranches && pendingBranches.length > 0) || needsBranchPin) {
    return <Navigate to="/select-branch" replace />;
  }
  if (roles && roles.length && !roles.includes(user.role)) {
    return <Navigate to="/app" replace />;
  }
  return children;
}
